export default __webpack_public_path__ + "static/media/04.27f042d0.gif";